export function parseBool(value: string | boolean): boolean {
  return Boolean(value) && Boolean(value.toString().toLowerCase() === 'true');
}

export function parseURI(inPath: string): string {
  inPath = decodeURI(inPath);
  if (!inPath.startsWith('/')) {
    inPath = `/${inPath}`;
  }
  if (inPath.endsWith('?')) {
    inPath = inPath.slice(0, -1);
  }
  return inPath;
}

export function parseJSON<T = unknown>(string: string): T | string {
  try {
    return JSON.parse(string);
  } catch (err) {
    try {
      const findNestedUnescapedQuote = /("{|"{[^}]*?[^\\}])"/g;
      let escapedString = string;
      while (findNestedUnescapedQuote.test(escapedString)) {
        escapedString = escapedString.replace(
          findNestedUnescapedQuote,
          '$1\\"',
        );
      }
      return JSON.parse(escapedString);
    } catch (err2) {
      // oh well :(
    }
    return string;
  }
}

export function parsePath(uri: string): string {
  return uri.split('?')[0];
}

export function parseBasePath(currentPath: string): string {
  const pathArr = currentPath.split('/');
  let rtnVal;

  if (pathArr && pathArr[1] && typeof pathArr[1] === 'string') {
    rtnVal = pathArr[1].toLowerCase();
  }

  return rtnVal;
}
